export default class MailCopy {
    constructor() {
        this.init();
    }

    init() {
        const buttons = document.querySelectorAll('.mail__btn');
        buttons.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.copyMail(btn);
            });
        });
    }

    copyMail(btn) {
        const mail = btn.dataset.mail;

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(mail)
                .then(() => this.showCopiedIcon(btn))
                .catch(err => console.error('Impossible de copier le mail', err));
        } else {
            const textarea = document.createElement('textarea');
            textarea.value = mail;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'absolute';
            textarea.style.left = '-9999px';
            textarea.style.top = window.pageYOffset + 'px'; // 👈 Fixe la position au scroll actuel
            document.body.appendChild(textarea);

            // Empêche le scroll lors du focus
            const scrollY = window.pageYOffset;
            textarea.focus({ preventScroll: true }); // 👈 Empêche le scroll
            textarea.select();

            try {
                document.execCommand('copy');
                this.showCopiedIcon(btn);
            } catch (err) {
                console.error('Impossible de copier le mail', err);
            }

            document.body.removeChild(textarea);
            window.scrollTo(0, scrollY); // 👈 Force le maintien de la position
        }
    }

    showCopiedIcon(btn) {
        const defaultIcon = btn.querySelector('.mail__icon--default');
        const copiedIcon = btn.querySelector('.mail__icon--copied');

        defaultIcon.style.display = 'none';
        copiedIcon.style.display = 'inline';

        setTimeout(() => {
            defaultIcon.style.display = 'inline';
            copiedIcon.style.display = 'none';
        }, 2000);
    }
}